<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%" @tab-click="handleTabClick">
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.CompanyCopy')" name="companyCopy" style="width:100%;height: 100%">
          <company-copy ref="companyCopy" :tab-title="$t('CargoMsg.CompanyCopy')" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.ChargeSchemeCopy')" name="chargeSchemeCopy" style="width:100%;height: 100%">
          <charge-scheme-copy ref="chargeSchemeCopy" :tab-title="$t('CargoMsg.ChargeSchemeCopy')" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

import companyCopy from '@/views/cargo/v0/SystemMaintenance/components/bachMove/companyCopy'
import chargeSchemeCopy from '@/views/cargo/v0/SystemMaintenance/components/bachMove/chargeSchemeCopy'

export default {
  name: 'BatchMove',
  components: {
    companyCopy,
    chargeSchemeCopy
  },
  data() {
    return {
      loading: true,
      useUserPort: false,
      activeTabName: 'companyCopy'
    }
  },
  watch: {
    $route: {
      handler: function(route) {
      },
      immediate: true
    }
  },
  mounted() {
  },
  async created() {
    this.loading = false
  },
  methods: {
    handleTabClick() {
    },
    onReady(params) {
    }
  }
}
</script>
